import { getHelp, updateHelp } from "./help-services";
import {
  getAttachments,
  createAttachment,
  updateAttachment,
  deleteAttachment,
} from "./help-attachment-services";

export {
  getHelp,
  updateHelp,
  getAttachments,
  createAttachment,
  updateAttachment,
  deleteAttachment,
};
